import React, { useState } from 'react';
import { useGlobal, useDispatch } from 'reactn';
import { NavLink } from 'react-router-dom';
import { Popover, Button } from 'equasion-lib';
import { FiMessageSquare } from 'react-icons/fi';
import { useRootStore } from '@/lib/providers/RootProvider';
import logo from '@/lib/images/logos/logo-white.svg';
import { FiMenu } from 'react-icons/fi';
import './NavMain.scss';

const NAV_LINKS = [
  {
    route: '/sales-orders',
    title: 'Sales Orders'
  },
  {
    route: '/bulk-stock',
    title: 'Bulk Stock'
  },
  {
    route: '/bulk-move',
    title: 'Bulk Move'
  },
  {
    route: '/unserialized',
    title: 'Inbound OTC/UPC'
  },
  {
    route: '/move-unserialized',
    title: 'Move OTC/UPC'
  },
  {
    route: '/quarantine-unserialized',
    title: 'Quarantine OTC/UPC'
  },
  {
    route: '/stock-unserialized',
    title: 'Stock OTC/UPC'
  },
  {
    route: '/destroy-unserialized',
    title: 'Destroy OTC/UPC'
  },
  {
    route: '/placeholder-purchase-orders',
    title: 'Approved Unserialized'
  },
  {
    route: '/pick-path-setup',
    title: 'Pick Path Setup'
  },
  {
    route: '/quarantine-cleanup',
    title: 'Quarantine Cleanup'
  },
  {
    route: '/zone-count',
    title: 'Zone Count'
  }
  // {
  //   route: '/missing',
  //   title: 'Missing Item Checker'
  // },
  // {
  //   route: '/profile',
  //   title: 'Profile'
  // }
];

function NavMain() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loggedIn] = useGlobal('userSession');
  const logout = useDispatch('logout');
  const currentUser = useRootStore((state: any) => state.currentUser) as any;
  const { firstName, lastName } = currentUser || {};
  const fullName = [firstName, lastName].filter(Boolean).join(' ');

  const menuItem = (path, text) => (
    <NavLink key={path} className="nav-link" to={path}>
      {text}
    </NavLink>
  );

  return (
    <nav className="main">
      <img className="logo" src={logo} />

      <button
        type="button"
        className="hamburger"
        aria-label="Open menu"
        onClick={() => setMenuOpen(true)}
      >
        <FiMenu />
      </button>
      <Popover
        isPopoverOpen={menuOpen}
        setIsPopoverOpen={(isOpen) => setMenuOpen(isOpen)}
        className="nav-menu"
        content={
          <div className="menu" onClick={() => setMenuOpen(false)}>
            {!!loggedIn && NAV_LINKS.map(({ route, title }) => menuItem(route, title))}
            <div onClick={logout} className="nav-link logout">
              Sign Out
              {!!fullName && <div className="user-name">{fullName}</div>}
            </div>
            <div className="nav-link submit-ticket">
              <Button
                type="secondary"
                size="compact"
                iconBefore={<FiMessageSquare />}
                onClick={() => window.open('https://rxerp.com/ticketing-form', '_blank')}
              >
                Submit Ticket
              </Button>
            </div>
          </div>
        }
      />
    </nav>
  );
}

export default NavMain;
